module.exports = "/_next/static/images/8944407e16dcbda0bd947b3901b0deff-doc.svg";